import { createContext, useRef, useState } from "react";
import * as bootstrap from "bootstrap";
import { Toast } from "bootstrap";
import { getMsg } from "../utils/validation";

const NotifyContext = createContext(null);

export default NotifyContext;

export function NotifyContextProvider({ children }) {
    const [option, setOption] = useState();

    const notifyRef = useRef();

    const toastMessage = (code, status = undefined, title = undefined, obj, message, delay = 3000) => {
        if (message) {
            title = "";
            status = notifyStatus.danger;
            showToast(message, status, title, notifyType.toast, obj, delay);
            return;
        }
        title = title == undefined ? "" : title;
        status = status == undefined ? notifyStatus.danger : status;
        const _code = parseInt(code);

        if (_code >= 100 && _code < 200) status = notifyStatus.success;
        showToast(getMsg(code), status, title, notifyType.toast, obj, delay);
    };

    const showToast = (desc, status, title, type, obj, delay = 3000) => {
        let temp = {
            desc: desc?.replace(/\u00A0/g, " ")?.replace(/&nbsp;/g, " "),
            status: status,
            title: title,
            type: type,
        };

        if (obj && desc) {
            temp.desc = replacePlaceholders(obj, desc);
        }
        setOption(temp);
        var myToast = notifyRef.current;
        // All toasts share this one element. Dispose any prior instance first so its pending
        // autohide timer is cleared — otherwise an earlier toast's (shorter) timer can fire on
        // this element and hide the new toast early, making longer messages flash briefly.
        var existing = bootstrap.Toast.getInstance(myToast);
        if (existing) existing.dispose();
        var bsToast = new Toast(myToast, { autohide: true, delay: delay ?? 3000 });
        setTimeout(() => {
            bsToast?.show();
        }, 100);
    };

    //  card toast 

    const notifyCard = (card) => {
        setOption({ type: "card", card });
        var myToast = notifyRef.current;
        bootstrap.Toast.getInstance(myToast);
        var bsToast = new Toast(myToast, { autohide: true, delay: card?.delay || 4000 });
        setTimeout(() => {
            bsToast?.show();
        }, 100);
    };

    function replacePlaceholders(obj, str) {
        return str.replace(/{(\w+)}/g, (match, key) => {
            return obj.hasOwnProperty(key) ? obj[key] : match;
        });
    }

    const closeToast = () => {
        var myToast = notifyRef.current;
        var bsToast = bootstrap.Toast.getInstance(myToast);
        bsToast?.hide();
    };

    const toastColor = (type) => {
        switch (type) {
            case "info":
                return "text-white bg-info";
            case "primary":
                return "text-white bg-primary";
            case "secondary":
                return "text-white bg-secondary";
            case "success":
                return "text-white bg-success";
            case "warning":
                return "text-dark bg-warning";
            case "light":
                return "text-white bg-light";
            case "dark":
                return "text-white bg-dark";
            case "danger":
                return "text-white bg-danger";
            default:
                return "";
        }
    };
    return (
        <NotifyContext.Provider
            value={{
                notifyParams: showToast,
                notifyToast: toastMessage,
                notifyCard: notifyCard,
                setShow: closeToast,
            }}
        >
            {children}
            <div className="position-fixed top-0 end-0 m-4">
                {option?.type === "card" ? (
                    <div className={`toast dc-call-toast accent-${option.card?.accent || ""}`} role="alert" ref={notifyRef} id="bs-toast">
                        <div className="dc-call-toast-row">
                            {option.card?.initials ? (
                                <div className="dc-call-toast-avatar">{option.card.initials}</div>
                            ) : option.card?.iconEl ? (
                                <div className="dc-call-toast-icon">{option.card.iconEl}</div>
                            ) : null}
                            <div className="dc-call-toast-body">
                                <div className="dc-call-toast-title">{option.card?.title}</div>
                                {option.card?.subtitle ? (
                                    <div className="dc-call-toast-sub">
                                        <span className="dc-call-toast-dot" />
                                        {option.card.subtitle}
                                    </div>
                                ) : null}
                            </div>
                            <button type="button" className="dc-call-toast-close" onClick={() => closeToast()} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                ) : (
                    <div
                        style={{
                            minWidth: "250px",
                            width: "auto",
                        }}
                        className={`toast ${toastColor(option?.status)}`}
                        role="alert"
                        ref={notifyRef}
                        id="bs-toast"
                    >
                        {option?.title == "" || option?.title == undefined ? (
                            ""
                        ) : (
                            <div className="toast-header">
                                <strong className="me-auto">{option?.title}</strong>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => closeToast()}
                                    aria-label="Close"
                                ></button>
                            </div>
                        )}

                        {option?.title == "" || option?.title == undefined ? (
                            <div className="d-flex">
                                <div className="toast-body textfield-wrap">
                                    {option?.desc == "" ? "" : option?.desc}
                                </div>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white me-2 m-auto"
                                    data-bs-dismiss="toast"
                                    aria-label="Close"
                                ></button>
                            </div>
                        ) : (
                            <div className="toast-body textfield-wrap">
                                {option?.desc == "" ? "" : option?.desc}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </NotifyContext.Provider>
    );
}

export const notifyType = {
    toast: "toast",
    alert: "alert",
};

export const notifyStatus = {
    info: "info",
    danger: "danger",
    primary: "primary",
    secondary: "secondary",
    success: "success",
    warning: "warning",
    light: "light",
    dark: "dark",
};
